import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, Loading, ViewController, ModalController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore } from 'angularfire2/firestore';
import { Storage } from '@ionic/storage';
import { HomePage } from '../home/home';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermsAndConditionsPage } from '../terms-and-conditions/terms-and-conditions';

@IonicPage()
@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html',
})
export class ChangePasswordPage {
  myForm: FormGroup;
  loading: Loading;
  parent: string;

  constructor(public viewCtrl: ViewController, private storage: Storage, public navCtrl: NavController, public navParams: NavParams, public fireAuth: AngularFireAuth, public formBuilder: FormBuilder, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public afs: AngularFirestore,private modalCtrl:ModalController) {
    this.myForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      repeatPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      agree: [false, [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]]
    });
    this.parent = navParams.get("parent");
  }

  onSubmit() {
    this.presentLoadingCustom();
    this.fireAuth.auth.signInWithEmailAndPassword(this.fireAuth.auth.currentUser.email, this.myForm.value.oldPassword).then(data => {
      this.fireAuth.auth.currentUser.updatePassword(this.myForm.value.newPassword).then(() => {
        this.afs.collection("Users").doc(this.fireAuth.auth.currentUser.uid).update({ 'isNewUser': false }).then(() => {
          this.loading.dismiss();
          this.presentToast("¡Contraseña actualizada!");
          this.navCtrl.setRoot(HomePage);
        }).catch((error) => {
          ////console.log(error);
          this.loading.dismiss();
          this.presentToast("Error desconocido");
        });
      }).catch((error) => {
        ////console.log(error);
        this.loading.dismiss();
        this.presentToast("Error desconocido");
      });
    }).catch((error) => {
      ////console.log(error);
      this.loading.dismiss();
      this.presentToast("La contraseña anterior no coincide.");
    });
  }

  ionViewDidLoad() { }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  cancel() {
    if (this.parent !== 'inicio') {
      this.navCtrl.pop();
    } else {
      this.logout();
    }
  }

  logout() {
    this.fireAuth.auth.signOut().then(() => {
      this.storage.clear();
    });
  }

  privacyPolicy() {
    let modal = this.modalCtrl.create(PrivacyPolicyPage);
    modal.present();
  }

  termsAndConditions() {
    let modal = this.modalCtrl.create(TermsAndConditionsPage);
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts